<template>
  <section class="img-holder">
    <div
      :style="{ 'background-image': `url(${thumb})` }"
      v-if="thumb"
      class="single"
    ></div>
    <div
      class="single"
      v-else-if="product.products.length === 1"
      :style="{
        'background-image': productThumb(product.products[0], 68)
      }"
    ></div>
    <div class="duo" v-else-if="product.products.length === 2">
      <div
        :style="{
          'background-image': productThumb(product.products[0], 32)
        }"
      ></div>
      <div
        :style="{
          'background-image': productThumb(product.products[1], 32)
        }"
      ></div>
    </div>
    <div class="four" v-else-if="product.products.length > 2">
      <div
        :style="{
          'background-image': productThumb(product.products[0], 32)
        }"
      ></div>
      <div
        :style="{
          'background-image': productThumb(product.products[1], 32)
        }"
      ></div>
      <div
        :style="{
          'background-image': productThumb(product.products[2], 32)
        }"
      ></div>
      <div
        v-if="product.products.length > 3"
        :style="{
          'background-image': productThumb(product.products[3], 32)
        }"
      ></div>
    </div>
  </section>
</template>

<script>
export default {
  props: ['product'],
  computed: {
    thumb() {
      if (this.product.previewImage) {
        return `/media/print-store/${this.product.printStoreId}/preview/${this.product.previewImage}/88`
      } else {
        return null
      }
    }
  },
  methods: {
    productThumb(val, size) {
      let image = val.previewImage || val.variant.previewImage

      return `url(/media/print-store/${this.product.printStoreId}/preview/${image}/${size})`
    }
  }
}
</script>

<style lang="scss" scoped>
.img-holder {
  width: 34px;
  height: 34px;
  flex-shrink: 0;
  flex-grow: 0;

  div {
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;

    &.single {
      width: 100%;
      height: 100%;
    }

    &.duo {
      height: 100%;
      display: flex;
      justify-content: space-between;
      > div {
        width: 16px;
        height: 100%;
      }
    }

    &.four {
      height: 100%;
      display: flex;
      flex-wrap: wrap;
      align-content: space-between;
      justify-content: space-between;
      > div {
        height: 16px;
        width: 16px;
      }
    }
  }
}
</style>
